<template>
  <div
    class="score-badge"
    :style="{
      backgroundColor: backgroundColor,
      borderColor: borderColor
    }"
  >
    <q-icon :name="icon" size="15px" style="margin-left: -1px" />
    <div class="score-badge__text text-capitalize">
      {{ phrase }}
    </div>
  </div>
</template>

<script>
import mixins from "@/mixins";

export default {
  name: "ScoreBadge",
  mixins: [mixins],
  props: {
    score: {
      type: [String, Number],
      default: ""
    }
  },
  computed: {
    numericScore() {
      return parseFloat(this.score);
    },
    phrase() {
      return this.convertScoreToDealPhrase(this.numericScore);
    },
    color() {
      return this.convertScoreToColor(this.numericScore);
    },
    backgroundColor() {
      return this.blendColor(this.color, 0.6);
    },
    borderColor() {
      return this.blendColor(this.color, 0.8);
    },
    icon() {
      const phrase = this.convertScoreToPhrase(this.numericScore).toLowerCase();
      const iconMap = {
        excellent: "sym_r_diamond",
        great: "sym_r_arrow_upward",
        good: "sym_r_north_east",
        fair: "sym_r_arrow_forward",
        poor: "sym_r_south_east"
      };
      return iconMap[phrase] || "sym_r_arrow_forward";
    }
  },
  methods: {
    blendColor(hexColor, alpha) {
      const hex = hexColor.replace("#", "");
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);

      // Blend with dark background (e.g., #1a1a1a)
      const bgR = 26,
        bgG = 26,
        bgB = 26;

      const blendedR = Math.round(bgR + (r - bgR) * alpha);
      const blendedG = Math.round(bgG + (g - bgG) * alpha);
      const blendedB = Math.round(bgB + (b - bgB) * alpha);

      return `#${blendedR.toString(16).padStart(2, "0")}${blendedG
        .toString(16)
        .padStart(2, "0")}${blendedB.toString(16).padStart(2, "0")}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.score-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 4px 8px;
  border-radius: 20px;
  font-size: 11.5px;
  font-weight: 600;
  border: 1px solid;
  color: color(text);

  .score-badge__text {
    line-height: 1.2;
  }
}
</style>
